import { assert } from '../Assert'

/**
 * @see https://nodejs.org/api/timers.html#setintervalcallback-delay-args
 */
export const MAX_SAFE_INTERVAL = 2147483647

/**
 * Will attempt to execute the given call back every so often as defined by the time parameter
 * May stop calls if process is stopped or becomes idle
 *
 * @param time in milliseconds
 * @returns a function to cancel the interval
 */
export const createInterval = (callback: VoidFunction, time: number): VoidFunction => {
    assert(time <= MAX_SAFE_INTERVAL, new Error(`Interval ${time} not supported`))
    const id = setInterval(callback, time)
    return () => clearInterval(id)
}
